import React from "react";
import { useToaster } from "../components/toaster";

const ToasterExample: React.FC = () => {
  const { showToaster } = useToaster();

  const showInfoToaster = () => {
    showToaster("This is an info message!", { type: "info" });
  };

  const showSuccessToaster = () => {
    showToaster("Operation completed successfully!", { type: "success" });
  };

  const showWarningToaster = () => {
    showToaster("This is a warning message!", { type: "warning" });
  };

  const showErrorToaster = () => {
    showToaster("An error occurred while processing your request.", {
      type: "error",
      errorId: "ERR_12345",
    });
  };

  const showLongDurationToaster = () => {
    showToaster("This message will stay for 30 seconds", {
      type: "info",
      duration: 30000,
    });
  };

  const showMultipleToasters = () => {
    showToaster("First notification", { type: "info" });
    setTimeout(
      () => showToaster("Second notification", { type: "success" }),
      500,
    );
    setTimeout(
      () => showToaster("Third notification", { type: "warning" }),
      1000,
    );
    setTimeout(
      () =>
        showToaster("Fourth notification", {
          type: "error",
          errorId: "ERR_001",
        }),
      1500,
    );
    setTimeout(() => showToaster("Fifth notification", { type: "info" }), 2000);
  };

  return (
    <div
      style={{
        padding: "20px",
        display: "flex",
        gap: "10px",
        flexWrap: "wrap",
      }}
    >
      <button onClick={showInfoToaster} className="roka-btn flat primary">
        Show Info
      </button>
      <button onClick={showSuccessToaster} className="roka-btn flat success">
        Show Success
      </button>
      <button onClick={showWarningToaster} className="roka-btn flat primary">
        Show Warning
      </button>
      <button onClick={showErrorToaster} className="roka-btn flat danger">
        Show Error with ID
      </button>
      <button
        onClick={showLongDurationToaster}
        className="roka-btn flat primary"
      >
        Show Long Duration
      </button>
      <button onClick={showMultipleToasters} className="roka-btn flat primary">
        Show Multiple (Test Pagination)
      </button>
    </div>
  );
};

export default ToasterExample;
